import { render } from "./productSorting.vue?vue&type=template&id=03512e22&scoped=true"
import script from "./productSorting.vue?vue&type=script&lang=js"
export * from "./productSorting.vue?vue&type=script&lang=js"

import "./../../assets/styles/sort.scss?vue&type=style&index=0&id=03512e22&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03512e22"]])

export default __exports__